import React from "react";
import useField, { useFieldProps } from "src/hooks/form/useField";
import UserAllocationFields from "./UserAllocationFields";

const useUserAllocation = (props: useFieldProps<{ isMandatory: boolean }>) => {
  const { isMandatory } = props.extraData || {};

  const formOptions = isMandatory ? {
    rules: [
      {
        validator: (rule, values, cb) => {
          if (values?.length) {
            values.forEach(field => {
              if (!field.values?.length) {
                return cb('Please enter all the mandatory fields.');
              }
            });
            return cb();
          }
          return cb('Please enter all the mandatory fields.');
        }
      }
    ],
  } : props.formOptions;

  const field = useField({
    ...props,
    formOptions,
  });
  // const field = useField(props);
  const decorator = (child: React.ReactElement): React.ReactNode => {
    return field.decorator(
      React.createElement(
        UserAllocationFields,
        {
          ...child.props,
          // ...props,
        },
      )
    );
  };

  return {
    ...field,
    decorator,
  };

};

export default useUserAllocation;
